// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"6":"p__wechat-auth__callback","33":"p__profile","54":"p__reports__print","152":"p__games__detail","408":"p__reports__detail","699":"p__invites__live","866":"p__index","878":"p__invites__detail","903":"p__invites","909":"p__join","941":"p__games__play"}[chunkId] || chunkId) + ".async.js";
};